import { Staff } from 'domain/staff';
import { AxiosResponse } from 'axios';
import moment from 'moment';
import { stringify } from 'querystring';
import { WeekShiftPatternDataStaff } from 'domain/master/general/weekShiftPatternDataStaff';
import ApiClient from './ApiClient';
import { OrgStatusType, Values } from 'utility/constants';
import { SalaryDataStaff } from 'domain/master/general/salaryDataStaff';
import { OrganizationDataStaff } from 'domain/master/general/organizationDataStaff';
import { EmploymentDataStaff } from 'domain/master/general/employmentDataStaff';
import { StaffOrganizationDeleteResult } from 'types/api/master';

export type Error = {
  error: string;
  defaultMessage: string;
}
type TRoleMaster = {
  accessLevel: number,
  accessLevelName: string | null,
  companyCode: string
  roleCode: string,
  roleId: string,
  roleName: string,
  users: number
}
export const postStaffInfo = async (inputType: number, menuType: string, staff: Staff, isConfirmed: boolean = false) => {
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const query = {
    loginStaffCode,
    inputType,
    tabIndex: 0,
    staffCode: inputType == 0 && menuType === '1' ? 'dummy' : staff.id.staffCode,
    isConfirmed: isConfirmed ? 1 : 0,
  };
  let str = '';
  if (staff.categoryAccessSetAry && staff.categoryAccessSetAry.length) {
    str += `${staff.categoryAccessSetAry.join(',')},`;
  }
  const strsunmit = str.slice(0, -1);
  let orgAccessSetArystr = '';
  orgAccessSetArystr += staff.orgAccessSetAry;
  const querysubmit = { ...query, categoryAccessSetAry: strsunmit, orgAccessSetAry: orgAccessSetArystr };
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).categoryAccessSetAry;
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).orgAccessSetAry;
  if (staff.nationality == 1) {
    delete (staff as any).passportNumber;
    delete (staff as any).dispPassportExpirationDate;
    delete (staff as any).residenceCardNumber;
    delete (staff as any).dispAlienRegistrationCardExpirationDate;
    delete (staff as any).dispResidenceCardExpirationDate;
    staff.statusResidence = 1;
  }

  const response = await post(staff, menuType, querysubmit);
  return response.data;
};

export const postAffiliateInfo = async (inputType: number, menuType: string, staff: Staff) => {
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const query = {
    loginStaffCode,
    inputType,
    tabIndex: 1,
    staffCode: inputType == 0 && menuType === '1' ? 'dummy' : staff.id.staffCode,
  };
  let str = '';
  if (staff.categoryAccessSetAry && staff.categoryAccessSetAry.length) {
    str += `${staff.categoryAccessSetAry.join(',')},`;
  }
  const strsunmit = str.slice(0, -1);
  let orgAccessSetArystr = '';
  orgAccessSetArystr += staff.orgAccessSetAry;
  const querysubmit = { ...query, categoryAccessSetAry: strsunmit, orgAccessSetAry: orgAccessSetArystr };
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).categoryAccessSetAry;
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).orgAccessSetAry;

  const response = await post(staff, menuType, querysubmit);
  return response.data;
};

export const postPermission = async (inputType: number, menuType: string, staff: Staff) => {
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const query = {
    loginStaffCode,
    inputType,
    tabIndex: 6,
    staffCode: inputType == 0 && menuType === '1' ? 'dummy' : staff.id.staffCode,
  };

  let str = '';
  if (staff.categoryAccessSetAry && staff.categoryAccessSetAry.length) {
    str += `${staff.categoryAccessSetAry.join(',')},`;
  }
  const strsunmit = str.slice(0, -1);
  let orgAccessSetArystr = '';
  orgAccessSetArystr += staff.orgAccessSetAry;
  // const querysubmit = { ...query, categoryAccessSetAry: strsunmit, orgAccessSetAry: orgAccessSetArystr };
  // temp do not need to use orgAccessSetArystr
  const querysubmit = { ...query, categoryAccessSetAry: strsunmit };
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).categoryAccessSetAry;
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).orgAccessSetAry;

  const response = await post(staff, menuType, querysubmit);
  // ---- end Method 2----
  return response.data;
};

export const postEmploymentInfo = async (inputType: number, menuType: string, staff: Staff) => {
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const query = {
    loginStaffCode,
    inputType,
    tabIndex: 2,
    staffCode: inputType == 0 && menuType === '1' ? 'dummy' : staff.id.staffCode,
  };
  let str = '';
  if (staff.categoryAccessSetAry && staff.categoryAccessSetAry.length) {
    str += `${staff.categoryAccessSetAry.join(',')},`;
  }
  const strsunmit = str.slice(0, -1);
  let orgAccessSetArystr = '';
  orgAccessSetArystr += staff.orgAccessSetAry;
  const querysubmit = { ...query, categoryAccessSetAry: strsunmit, orgAccessSetAry: orgAccessSetArystr };
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).categoryAccessSetAry;
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).orgAccessSetAry;

  const response = await post(staff, menuType, querysubmit);
  return response.data;
};

export const postSalaryInfo = async (inputType: number, menuType: string, staff: Staff) => {
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const query = {
    loginStaffCode,
    inputType,
    tabIndex: 3,
    staffCode: inputType == 0 && menuType === '1' ? 'dummy' : staff.id.staffCode,
  };
  let str = '';
  if (staff.categoryAccessSetAry && staff.categoryAccessSetAry.length) {
    str += `${staff.categoryAccessSetAry.join(',')},`;
  }
  const strsunmit = str.slice(0, -1);
  let orgAccessSetArystr = '';
  orgAccessSetArystr += staff.orgAccessSetAry;
  const querysubmit = { ...query, categoryAccessSetAry: strsunmit, orgAccessSetAry: orgAccessSetArystr };
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).categoryAccessSetAry;
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).orgAccessSetAry;

  const response = await post(staff, menuType, querysubmit);
  return response.data;
};

export const postWorkPatternInfo = async (inputType: number, menuType: string, staff: Staff) => {
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const query = {
    loginStaffCode,
    inputType,
    tabIndex: 4,
    staffCode: inputType == 0 && menuType === '1' ? 'dummy' : staff.id.staffCode,
  };
  let str = '';
  if (staff.categoryAccessSetAry && staff.categoryAccessSetAry.length) {
    str += `${staff.categoryAccessSetAry.join(',')},`;
  }
  const strsunmit = str.slice(0, -1);
  let orgAccessSetArystr = '';
  orgAccessSetArystr += staff.orgAccessSetAry;
  const querysubmit = { ...query, categoryAccessSetAry: strsunmit, orgAccessSetAry: orgAccessSetArystr };
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).categoryAccessSetAry;
  // eslint-disable-next-line no-param-reassign
  delete (staff as any).orgAccessSetAry;

  const response = await post(staff, menuType, querysubmit);
  return response.data;
};

const post = async (staff: Staff, menuType: string, query: { [key: string]: string | number }) => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  let url = '/v4/staffs/';
  if (menuType === '1') {
    url += 'shop/';
  }
  url += companyCode;
  const response = await ApiClient.postMutipartData(url, query, staff);
  // const response = await ApiClient.postMutipartData(`/v2/staffs/${companyCode}`, query, staff);
  // const response = await ApiClient.postMutipartData(`/v2/staffs/shop/${companyCode}`, query, staff);
  return response;
};


// const post1 = async (staff: Staff, query: string) => {
//   const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
//   const response = await ApiClient.postMutipartDatastr(`/v2/staffs/${companyCode}`, query, staff);
//   return response;
// };


export const getAllAdminOrAttendanceStaff = async (): Promise<Array<Staff>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v2/staffs/adminOrAttendanceRole/${companyCode}`, {});
  return response.data;
};

export const getHqStaff = async (): Promise<Array<Staff>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  //const response = await ApiClient.get(`/v1/staffs/hqRole/${companyCode}`, {});
  const response = await ApiClient.get(`/v2/staffs/adminOrAttendanceRole/${companyCode}`, {});
  return response.data;
};

export const getListStaff = async (
  orgCode: string,
  executiveId: string,
  employmentId: string,
  stateStatus: Array<number>,
  categoryAry: any,
  orgStatus: OrgStatusType,
  menuId?: string,
): Promise<Array<Staff>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  let appendUrl = '';
  if (Array.isArray(categoryAry)) {
    categoryAry.forEach((cateArr: any, index: number) => {
      appendUrl += `&categoryAry=${cateArr.join(',')}`;
    });
  }
  const params: any = {
    orgCode,
    executiveId,
    employmentId,
    stateStatus,
    functionType: 1,
    loginStaffCode,
    orgStatus,
  };
  if (menuId) {
    params.menuId = menuId;
  }
  const queryStringParams = stringify(params);
  const response = await ApiClient.get(`/v3/staffs/list/${companyCode}`, {}, queryStringParams + appendUrl);
  return response.data;
};

export const getListShopStaff = async (
  orgCode: string,
  executiveId: string,
  employmentId: string,
  stateStatus: Array<number>,
  categoryAry: any,
  orgStatus: OrgStatusType,
): Promise<Array<Staff>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  let appendUrl = '';
  if (Array.isArray(categoryAry)) {
    categoryAry.forEach((cateArr: any, index: number) => {
      appendUrl += `&categoryAry=${cateArr.join(',')}`;
    });
  }
  const params = {
    orgCode,
    executiveId,
    employmentId,
    stateStatus,
    functionType: Values.FunctionType.Master.value,
    loginStaffCode,
    orgStatus
  };
  const queryStringParams = stringify(params);
  const response = await ApiClient.get(`/v3/staffs/employee/list/${companyCode}`, {}, queryStringParams + appendUrl);
  return response.data;
};

// TODO: /v2/staffs/listをコールしていない理由を要確認
export const getStaffListForOrgCode = async (orgCode: string): Promise<Array<any>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v1/staffs/list/${companyCode}?orgCode=${orgCode}&stateStatus=1&stateStatus=3&stateStatus=4`, {});
  return response.data;
};

export const getLoginStaff = async () => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const staffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const response = await ApiClient.get(`/v1/staffs/${companyCode}`, {}, {
    staffCode,
  });
  return response.data;
};

export const getSpecificStaff = async (staffCode: string) => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.get(`/v2/staffs/${companyCode}`, {}, {
    staffCode,
  });
  return response.data;
};

/**
 * CSV Import & download
 */
export const postStaffCsvImport = async (formatType: string, uploadFile: File)
  : Promise<AxiosResponse> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const staffName = sessionStorage.getItem('loginUser.staffName') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  const query = {
    loginStaffCode,
    formatType,
    createUser: staffName,
    updateUser: staffName,
  };
  const response = await ApiClient.postFile(`/v3/staffs/csv/${companyCode}`, query, 'uploadFile', uploadFile);
  return response;
};

export const downloadStaffCsv = async (
  orgCode: string,
  executiveId: string,
  employmentId: string,
  stateStatus: Array<number>,
  categoryAry: any,
  orgStatus: OrgStatusType
): Promise<void> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  let appendUrl = '';
  if (Array.isArray(categoryAry)) {
    categoryAry.forEach((cateArr: any, index: number) => {
      appendUrl += `&categoryAry=${cateArr.join(',')}`;
    });
  }
  const params = {
    orgCode,
    executiveId,
    employmentId,
    stateStatus,
    functionType: Values.FunctionType.Master.value,
    loginStaffCode,
    orgStatus,
  };
  const queryStringParams = stringify(params);
  await ApiClient.downloadOriginalCsv(`/v3/staffs/csv/${companyCode}`, queryStringParams + appendUrl, getDownloadCsvFileName('スタッフ情報_'));
};

export const downloadStaffSalaryCsv = async (
  orgCode: string,
  executiveId: string,
  employmentId: string,
  stateStatus: Array<number>,
  categoryAry: any,
  orgStatus: OrgStatusType
): Promise<void> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  let appendUrl = '';
  if (Array.isArray(categoryAry)) {
    categoryAry.forEach((cateArr: any, index: number) => {
      appendUrl += `&categoryAry=${cateArr.join(',')}`;
    });
  }
  const params = {
    orgCode,
    executiveId,
    employmentId,
    stateStatus,
    functionType: Values.FunctionType.Master.value,
    loginStaffCode,
    orgStatus,
  };
  const queryStringParams = stringify(params);
  await ApiClient.downloadOriginalCsv(`/v3/staffs/salary/csv/${companyCode}`, queryStringParams + appendUrl, getDownloadCsvFileName('スタッフ人件費情報_'));
};

export const downloadStaffManagerCsv = async (
  orgCode: string,
  executiveId: string,
  employmentId: string,
  stateStatus: Array<number>,
  categoryAry: any,
  orgStatus: OrgStatusType
): Promise<void> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  let appendUrl = '';
  if (Array.isArray(categoryAry)) {
    categoryAry.forEach((cateArr: any, index: number) => {
      appendUrl += `&categoryAry=${cateArr.join(',')}`;
    });
  }
  const params = {
    orgCode,
    executiveId,
    employmentId,
    stateStatus,
    functionType: Values.FunctionType.Master.value,
    loginStaffCode,
    orgStatus,
  };
  const queryStringParams = stringify(params);
  await ApiClient.downloadOriginalCsv(`/v3/staffs/manager/csv/${companyCode}`, queryStringParams + appendUrl, getDownloadCsvFileName('スタッフマネージャー権限_'));
};


export const deleteStaff = async (staffCode: string): Promise<void> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const loginStaffCode = sessionStorage.getItem('loginUser.staffCode') || '';
  await ApiClient.delete(`/v2/staffs/${companyCode}`, { staffCode, loginStaffCode });
};

export const deleteStaffOrganization = async (staffCode: string, applyStartDate: Date):
  Promise<StaffOrganizationDeleteResult> => {
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
    const response = await ApiClient.delete(`/v2/staffs/organization/${companyCode}`, { staffCode, applyStartDate: moment(applyStartDate).format('YYYY-MM-DD') });
    return response.data;
};

export const deleteStaffEmployment = async (staffCode: string, applyStartDate: Date):
  Promise<Array<EmploymentDataStaff>> => {
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
    const response = await ApiClient.delete(`/v2/staffs/employment/${companyCode}`, { staffCode, applyStartDate: moment(applyStartDate).format('YYYY-MM-DD') });
    return response.data;
};

export const deleteStaffSalary = async (staffCode: string, staffSalaryId: string):
  Promise<Array<SalaryDataStaff>> => {
    const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
    const response = await ApiClient.delete(`/v2/staffs/salary/${companyCode}`, { staffCode, staffSalaryId });
    return response.data;
};

export const deleteWeekShiftPatternStaff = async (staffWeekShiftId: string):
  Promise<Array<WeekShiftPatternDataStaff>> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const response = await ApiClient.delete(`/v1/staffs/patterns/${companyCode}`, { staffWeekShiftId });
  return response.data;
};

export const getShiftPatternStaff = async (
  orgCode: string,
  employmentId: string,
  staffCode: string,
  isEditMode: boolean,
): Promise<Staff> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const params = {
    inputType: isEditMode ? 1 : 0,
    staffCode: isEditMode ? staffCode : '',
    orgCode,
    employmentId,
  };
  const queryStringParams = stringify(params);
  const response = await ApiClient.get(`/v2/staffs/shiftpattern/${companyCode}`, {}, queryStringParams);
  return response.data;
};

const getDownloadCsvFileName = (prefix: string) => `${prefix}${moment().format('YYYYMMDDHHmmss')}.csv`;

// スタッフ情報の登録
export const postStaffPhoto = async (dataPost: any): Promise<any> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const params = {
    dataType: 1,
  };

  const response = await ApiClient.postMutipartData(`/v1/staffs/photos/${companyCode}`, params, dataPost);
  return response.data;
};

// getList for SelectBox
export const getRolesMasterList = async (): Promise<TRoleMaster[]> => {
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const staffCode = sessionStorage.getItem('loginUser.staffCode') || '';

  const params = {
    staffCode,
    fields: ''
  }
  const response = await ApiClient.get(`/v1/roles/list/${companyCode}`, {}, params)
  return response.data
}

export const getStaffCodeV2 = async ():Promise<any>=>{
  const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
  const staffCode = sessionStorage.getItem('loginUser.staffCode') || '';

  const params = {
    staffCode
  }
  const response = await ApiClient.get(`/v2/staffs/${companyCode}`,params);
  return response.data

}

export default {
  getAllAdminOrAttendanceStaff,
  getHqStaff,
};
